import RemoveRow from "./remove-row";

export default RemoveRow;